import { useState } from 'react';
import { headTableCells } from 'containers/pages/activityLogManagement/data';

function useActivityLogList() {
  const [order, setOrder] = useState<'asc' | 'desc'>('asc');
  const [orderBy, setOrderBy] = useState('');
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const onRequestSort = (_e: React.MouseEvent, property: string) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const onSort = (property: string) => (e: React.MouseEvent) => {
    onRequestSort(e, property);
  };

  const onToggleExpand = (id: number) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((sid) => sid !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const state = { headTableCells, order, orderBy, selectedIds };
  const handler = { onRequestSort, onSort, onToggleExpand };

  return { state, handler };
}

export default useActivityLogList;
